module.exports = __webpack_public_path__ + "img/img37.eecc1f58.svg";